export const DEFAULT_EMOJI_PRIORITIES_LIST = [
  "+1",
  "-1",
  "heart",
  "heart_eyes",
  "tada",
  "partying_face",
  "joy",
  "sob",
  "white_frowning_face",
  "rocket",
  "eyes",
  "raised_hands",
  "open_mouth",
];

export const EMOJI_QUERY_REGEX = /^[a-z0-9_+-]+$/i;
